'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _lodash = require('lodash');
var _reactScroll = require('react-scroll');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _uniqueId = require('lodash/uniqueId');var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _components = require('../../components');

var _constants = require('./constants');

var _PublishNewHomesForm = require('./PublishNewHomesForm.scss');var styles = _interopRequireWildcard(_PublishNewHomesForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

ProjectImages = function (_Component) {_inherits(ProjectImages, _Component);function ProjectImages() {var _temp, _this, _ret;_classCallCheck(this, ProjectImages);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      uploadPhotoInProgress: null,
      isChangeImg: false }, _this.








    deleteImages = function (id, name) {
      var images = _this.props.fields.projectImages;
      var formData = images.filter(function (item) {return item._id !== id;});
      _this.props.updateContent(name, formData);
    }, _this.

    rotateImage = function (id, newAngle, name) {
      var images = _this.props.fields.projectImages;
      var formData = images.map(function (item) {
        var angle = item.angle;

        if (id === item._id) {
          angle = newAngle;
        }

        return Object.assign({}, item, { angle: angle });
      });

      _this.props.updateContent(name, formData);
    }, _this.

    addDescription = function (id, newDescription) {
      var images = _this.props.fields.projectImages;
      var formData = images.map(function (item) {
        var description = item.description;

        if (id === item._id) {
          description = newDescription;
        }

        return Object.assign({}, item, { description: description });
      });

      _this.props.updateContent('projectImages', formData);
    }, _this.

    formatInitialImages = function () {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      _this.formattedImages = data.map(function (_ref)







      {var publicId = _ref.public_id,description = _ref.description,angle = _ref.angle,relativeAngle = _ref.relativeAngle,full = _ref.full,thumbnail = _ref.thumbnail,_id = _ref._id;
        var imageAngle = _components.UploadAssetWidget.getAngle({ angle: angle, full: full });
        var linkId = publicId || full && full.split('/').pop();

        return {
          thumbnail: thumbnail,
          full: full,
          link: linkId,
          description: description,
          angle: imageAngle,
          relativeAngle: relativeAngle || 0,
          contentType: 'image',
          _id: _id || 'upload_image_' + linkId };

      });
      return _this.formattedImages;
    }, _this.

    updateContent = function (data) {return _this.props.updateContent('projectImages', data);}, _this.
    changeImages = function (data) {
      var photos = _this.formattedImages || _this.formatInitialImages(data);

      _this.props.updateContent('projectImages', photos);
    }, _this.

    renderUploadAssetWidget = function (_ref2) {var _ref2$meta = _ref2.meta,meta = _ref2$meta === undefined ? {} : _ref2$meta,classNames = _ref2.classNames,_ref2$input = _ref2.input;_ref2$input = _ref2$input === undefined ? {} : _ref2$input;var name = _ref2$input.name,multiple = _ref2.multiple;var
      touched = meta.touched,error = meta.error;
      var deleteImages = function deleteImages(id) {return _this.deleteImages(id, name);};
      var rotateImage = function rotateImage(id, newAngle) {return _this.rotateImage(id, newAngle, name);};

      return (
        _react2.default.createElement('div', { className: styles.widget },
          _react2.default.createElement(_components.UploadAssetWidget, {
            multiple: multiple,
            withOutVideo: true,
            openMessageModal: _this.props.openMessageModal,
            initialImages: _this.props.fields.projectImages && (
            _this.formattedImages || _this.formatInitialImages(_this.props.fields.projectImages)),
            translate: _this.props.translate('addNewProject', 'uploadWidget'),
            rootTranslate: _this.props.translate,
            isMobile: _this.props.isMobile,
            uploadInProgress: function uploadInProgress(status) {return _this.setState({ uploadPhotoInProgress: status });},
            contentUploaded: _this.updateContent,
            updateContent: _this.updateContent,
            markAssetToDelete: _this.props.addAssetToDelete,
            suspendedUpload: true,
            className: (0, _classnames2.default)(classNames, { 'has-error': !!error && touched, touched: touched }),
            deleteContentItem: deleteImages,
            addDescription: _this.addDescription,
            rotateImage: rotateImage,
            userToken: (0, _lodash.get)(_this.props, 'userData.data.access_token') }),

          !!error && touched && _react2.default.createElement('span', { className: styles.required }, _this.props.translate('errorFieldMessages', 'required')),
          _react2.default.createElement('div', { className: styles.message },
            _this.props.translate('uploadWidget', 'fileSizeMessage'))));



    }, _temp), _possibleConstructorReturn(_this, _ret);}ProjectImages.prototype.componentDidMount = function componentDidMount() {if (this.props.fields.projectImages) {this.changeImages(this.props.fields.projectImages);}};ProjectImages.prototype.

  render = function render() {
    return (
      _react2.default.createElement(_reactScroll.Element, { name: _constants.PROJECT_FIELDS_NAMES.projectImages, className: styles.sectionBlockImages },
        _react2.default.createElement('div', { className: styles.label },
          this.props.translate('addNewProject', 'images'),
          _react2.default.createElement('span', { className: 'req' }, '*')),

        _react2.default.createElement(_reduxForm.Field, {
          name: _constants.PROJECT_FIELDS_NAMES.projectImages,
          props: { multiple: true },
          component: this.renderUploadAssetWidget })));



  };return ProjectImages;}(_react.Component);exports.default = ProjectImages;


ProjectImages.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  isMobile: _propTypes2.default.bool,
  updateContent: _propTypes2.default.func,
  error: _propTypes2.default.object,
  fields: _propTypes2.default.object,
  initialValues: _propTypes2.default.object,
  addAssetToDelete: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  token: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishNewHomesForm/ProjectImages.js
// module id = 3040
// module chunks = 0